import React from "react";

function SkeletonCard() {
  return (
    <div className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-white/[0.05] dark:shadow-black/20">
      <div className="h-56 animate-pulse bg-slate-200 dark:bg-white/10" />

      <div className="space-y-4 p-5">
        <div className="h-5 w-3/4 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
        <div className="h-4 w-full animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
        <div className="h-4 w-5/6 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />

        <div className="flex gap-2">
          <div className="h-8 w-24 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
          <div className="h-8 w-28 animate-pulse rounded-full bg-slate-200 dark:bg-white/10" />
        </div>

        <div className="grid gap-3 sm:grid-cols-2">
          <div className="h-20 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
          <div className="h-20 animate-pulse rounded-2xl bg-slate-200 dark:bg-white/10" />
        </div>
      </div>
    </div>
  );
}

function SharedEventsSkeleton() {
  return (
    <div className="mt-6 grid gap-5 lg:grid-cols-2">
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
      <SkeletonCard />
    </div>
  );
}

export default SharedEventsSkeleton;